module.exports = __webpack_public_path__ + "static/media/toothbrush.f1d7ea26.svg";